// extracted by mini-css-extract-plugin
export var Header = "styles-module--Header--g6ClG";
export var Header_ImageContent = "styles-module--Header_ImageContent--JGWGr";
export var Header_Title = "styles-module--Header_Title--bESMF";